import dayjs from "dayjs";
import { useLang } from "hooks/useLang";
import "dayjs/locale/ar";
import "dayjs/locale/en";

interface IProps {
    startTime: string | Date;
    endTime: string | Date;
    className?: string;
}

const TimeRange = ({ startTime, endTime, className }: IProps) => {
    const { isAr } = useLang();

    const formatTime = (date: string | Date) => {
        return dayjs(date).locale(isAr ? "ar" : "en").format("h:mm A");
    };

    return (
        <span className={className}>
            <bdi dir="ltr">{formatTime(startTime)}</bdi> - <bdi dir="ltr">{formatTime(endTime)}</bdi>
        </span>
    );
};

export default TimeRange;
